import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from 'src/constants';
import type { PreviouslyLicensedDTO } from 'app/domain';
import useApi from './useApi';

const NOTHING_LICENSED: ReadonlySet<string> = new Set();

const toLicensedAssetIds = (dto: PreviouslyLicensedDTO): ReadonlySet<string> =>
  new Set(dto.licensedAssetIds);

// Which of `assetIds` the account has already licensed. Does not suspend: the
// answer only decorates assets, so until it arrives (or if it fails) nothing
// is licensed. An empty list fetches nothing.
const usePreviouslyLicensedAssetIds = (
  assetIds: readonly string[]
): ReadonlySet<string> => {
  const { previouslyLicensedService } = useApi();

  const { data } = useQuery({
    queryKey: [...QUERY_KEYS.previouslyLicensed, assetIds],
    queryFn: () => previouslyLicensedService.get(assetIds),
    enabled: assetIds.length > 0,
    select: toLicensedAssetIds,
  });

  return data ?? NOTHING_LICENSED;
};

export default usePreviouslyLicensedAssetIds;
